
const object2String = Object.prototype.toString;
const functionString = '[object Function]';

class Ticker {

  static get sharedTicker() {
    return shared;
  }

  constructor() {
    this._rafID = 0;
    this._listeners = [];
    this._isRunning = false;

    this._tick = this._tick.bind(this);
  }

  get isRunning() {
    return this._isRunning;
  }

  addListener(listener) {

    if(object2String.call(listener) !== functionString) {
      return false;
    }

    if(this._listeners.indexOf(listener) === -1) {
      this._listeners.push(listener);
      return true;
    }

    return false;
  }

  removeListener(listener) {

    if(object2String.call(listener) !== functionString) {
      return null;
    }

    const index = this._listeners.indexOf(listener);
    let removed;


    if(index > -1) {
      removed = this._listeners[index];
      this._listeners[index] = null;

      return removed;
    }

    return null;
  }

  start() {
    if(this._isRunning) {
      return;
    }

    this._isRunning = true;
    this._rafID = requestAnimationFrame(this._tick);
  }

  stop() {
    if(!this._isRunning) {
      return;
    }

    this._isRunning = false;

    cancelAnimationFrame(this._rafID);
    this._rafID = 0;
  }

  _tick() {

    if(!this._isRunning) {
      return;
    }

    this._rafID = requestAnimationFrame(this._tick);

    if(this._listeners.length === 0) {
      return;
    }

    let listener;
    let swipeListener;

    for(let i = 0, iz = this._listeners.length; i<iz; i++) {

      listener = this._listeners[i];

      if(listener) {
        listener();
      } else {
        swipeListener = true;
      }
    }

    if(swipeListener) {
      const nextListeners = [];

      for(let j = 0, jz = this._listeners.length; j<jz; j++) {
        listener = this._listeners[j];

        if(listener) {
          nextListeners.push(listener);
        }
      }

      this._listeners = nextListeners;
    }
  }
}

const shared = new Ticker();
shared.start();

export default Ticker;



// WEBPACK FOOTER //
// ./src/js/app/utils/Ticker.js